import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import PropTypes from "prop-types";

import FormAttachmentsView  from "components/FormAttachmentsView";
import { API_SUBAWARD, COLUMN_HEADER_KEYS } from "globals/constants";
import { useFormAccesses } from "hooks";
import { shellSelectors, tenantSelectors } from "store/selectors";
import { spUrl } from "utils";


const SubawardAttachmentsView = ({ tabsRef, formTabText, setJustActivatedSectionLabel, isUploading, setIsUploading }) => {
	const { awardId, subawardId } = useParams();
	const { fullName } = useSelector(shellSelectors.user);
	const { attachmentTypes } = useSelector(tenantSelectors.tenant);

	const formAccesses = useFormAccesses("subaward", subawardId);

	const {
		formInstance,
		attachmentsUrl,
		awardAttachmentTypes,
	} = useMemo(() => ({
		attachmentsUrl: spUrl(`${API_SUBAWARD}/${subawardId}/attachments`),
		awardAttachmentTypes: attachmentTypes["PROPOSAL"],
		formInstance: {
			instanceId: subawardId,
			endpoint: API_SUBAWARD,
			type: COLUMN_HEADER_KEYS.AWARD
		},
	}), [ attachmentTypes ]);

	return (
		<FormAttachmentsView
			formInstance={formInstance}
			fullName={fullName}
			attachmentTypes={awardAttachmentTypes}
			attachmentsUrl={attachmentsUrl}
			tabsRef={tabsRef}
			formTabText={formTabText}
			canAddAttachments={formAccesses.addContent}
			canEditAttachments={formAccesses.updateContent}
			setJustActivatedSectionLabel={setJustActivatedSectionLabel}
			setIsUploading={setIsUploading}
			isUploading={isUploading}
		/>
	);
};

SubawardAttachmentsView.propTypes = {
	setJustActivatedSectionLabel: PropTypes.func.isRequired,
	tabsRef: PropTypes.object,
};

export default SubawardAttachmentsView;
